<template>
  <div id="portal-setting">
    <div class="labelTitle lable title-area">ポータル設定</div>
    <!-- tab header -->
    <div class="content-area">
      <b-tabs type="is-boxed">
        <!-- 掲載記事タブ -->
        <b-tab-item label="掲載記事" class="is-primary">
          <div style="text-align: left">
            <select
              v-model="articleType"
              @change="loadPortalArticle()"
              style="width: 200px; border-radius: 4px; height: 36px"
            >
              <option value="1" selected>お知らせ</option>
              <option value="2">ご案内</option>
              <option value="3">学会・イベント情報</option>
              <option value="4">ニュース</option>
              <option value="5">製品情報</option>
            </select>
          </div>
          <div>
            <div class="button-area">
              <b-button
                v-show="articleType == 1"
                class="is-primary"
                @click="goToArticleEdit(1)"
                >新規作成</b-button
              >
              <b-button
                v-show="articleType == 2"
                class="is-primary"
                @click="goToArticleEdit(2)"
                >新規作成</b-button
              >
              <b-button
                v-show="articleType == 3"
                class="is-primary"
                @click="goToArticleEdit(3)"
                >新規作成</b-button
              >
              <b-button
                v-show="articleType == 4"
                class="is-primary"
                @click="goToArticleEdit(4)"
                >新規作成</b-button
              >
              <b-button
                v-show="articleType == 5"
                class="is-primary"
                @click="goToArticleEdit(5)"
                >新規作成</b-button
              >
            </div>
            <div v-show="articleType == 1">
              <b-table
                :data="listOfNoticeData"
                :paginated="true"
                per-page="50"
                pagination-position="both"
                class="notice-table"
              >
                <template slot-scope="props">
                  <b-table-column field="title" label="タイトル" sortable>
                    {{ props.row.title }}
                  </b-table-column>
                  <b-table-column field="content" label="本文" sortable>
                    {{ props.row.content }}
                  </b-table-column>
                  <b-table-column
                    field="createdAt"
                    label="作成日"
                    class="nowrap"
                    style="font-size: 12px"
                    centered
                    sortable
                  >
                    {{ props.row.createdAt }}
                  </b-table-column>
                  <b-table-column class="edit-icon" label="編集" centered>
                    <a @click="goToArticleEdit(1, props.row.articleId)">
                      <b-icon icon="clipboard-edit-outline" />
                    </a>
                  </b-table-column>
                  <b-table-column class="delete-icon" label="削除" centered>
                    <a @click="deleteArticle(props.row.articleId)">
                      <b-icon icon="delete-forever-outline" />
                    </a>
                  </b-table-column>
                </template>
              </b-table>
            </div>
            <div v-show="articleType == 2">
              <b-table
                :data="listOfGuidanceData"
                :paginated="true"
                per-page="50"
                pagination-position="both"
                class="guidance-table"
              >
                <template slot-scope="props">
                  <b-table-column field="title" label="タイトル" sortable>
                    {{ props.row.title }}
                  </b-table-column>
                  <b-table-column field="classification_code" label="分類">
                    {{ props.row.classificationName }}
                  </b-table-column>
                  <b-table-column field="product_code" label="製品名">
                    {{ props.row.productNames }}
                  </b-table-column>
                  <b-table-column field="pdfUrl" label="PDF閲覧" centered>
                    <a @click="downloadFile(props.row.pdfFileUrl)"
                      ><b-icon icon="clipboard-arrow-right-outline"
                    /></a>
                  </b-table-column>
                  <b-table-column
                    field="createdAt"
                    label="作成日"
                    style="font-size: 12px; width: 80px"
                    centered
                    sortable
                  >
                    {{ props.row.createdAt }}
                  </b-table-column>
                  <b-table-column class="edit-icon" label="編集" centered>
                    <a @click="goToArticleEdit(2, props.row.articleId)">
                      <b-icon icon="clipboard-edit-outline" />
                    </a>
                  </b-table-column>
                  <b-table-column class="delete-icon" label="削除" centered>
                    <a @click="deleteArticle(props.row.articleId)">
                      <b-icon icon="delete-forever-outline" />
                    </a>
                  </b-table-column>
                </template>
              </b-table>
            </div>
            <div v-show="articleType == 3">
              <b-table
                :data="listOfEventData"
                :paginated="true"
                per-page="25"
                pagination-position="both"
                class="event-table"
              >
                <template slot-scope="props">
                  <b-table-column field="imageFileUrl" label="画像">
                    <img
                      :src="props.row.imageFileUrl"
                      class="image-file"
                      v-if="props.row.imageFileUrl"
                    />
                    <img
                      src="@/assets/image-off-outline.svg"
                      class="image-file"
                      v-else
                    />
                  </b-table-column>
                  <b-table-column field="title" label="タイトル" sortable>
                    {{ props.row.title }}
                  </b-table-column>
                  <b-table-column field="remarks" label="備考" sortable>
                    {{ props.row.remarks }}
                  </b-table-column>
                  <b-table-column field="pdfUrl" label="PDF閲覧" centered>
                    <a @click="downloadFile(props.row.pdfFileUrl)"
                      ><b-icon icon="clipboard-arrow-right-outline"
                    /></a>
                  </b-table-column>
                  <b-table-column
                    filed="externalUrl"
                    label="関連サイト"
                    centered
                  >
                    <a
                      v-if="props.row.externalLinkUrl"
                      @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                      class="infoicon"
                      ><b-icon icon="earth-arrow-right"
                    /></a>
                  </b-table-column>
                  <b-table-column
                    field="createdAt"
                    label="作成日"
                    style="font-size: 12px"
                    centered
                    sortable
                  >
                    {{ props.row.createdAt }}
                  </b-table-column>
                  <b-table-column class="edit-icon" label="編集" centered>
                    <a @click="goToArticleEdit(3, props.row.articleId)">
                      <b-icon icon="clipboard-edit-outline" />
                    </a>
                  </b-table-column>
                  <b-table-column class="delete-icon" label="削除" centered>
                    <a @click="deleteArticle(props.row.articleId)">
                      <b-icon icon="delete-forever-outline" />
                    </a>
                  </b-table-column>
                </template>
              </b-table>
            </div>
            <div v-show="articleType == 4">
              <b-table
                :data="listOfNewsData"
                :paginated="true"
                per-page="25"
                pagination-position="both"
                class="news-table"
              >
                <template slot-scope="props">
                  <b-table-column field="imageSrcUrl" label="画像">
                    <img
                      :src="props.row.imageFileUrl"
                      class="image-file"
                      v-if="props.row.imageFileUrl"
                    />
                    <img
                      src="@/assets/image-off-outline.svg"
                      class="image-file"
                      v-else
                    />
                  </b-table-column>
                  <b-table-column field="title" label="タイトル" sortable>
                    {{ props.row.title }}
                  </b-table-column>
                  <b-table-column
                    field="createdAt"
                    label="作成日"
                    style="font-size: 12px"
                    centered
                    sortable
                  >
                    {{ props.row.createdAt }}
                  </b-table-column>
                  <b-table-column class="edit-icon" label="編集" centered>
                    <a @click="goToArticleEdit(4, props.row.articleId)">
                      <b-icon icon="clipboard-edit-outline" />
                    </a>
                  </b-table-column>
                  <b-table-column class="delete-icon" label="削除" centered>
                    <a @click="deleteArticle(props.row.articleId)">
                      <b-icon icon="delete-forever-outline" />
                    </a>
                  </b-table-column>
                </template>
              </b-table>
            </div>
            <div v-show="articleType == 5">
              <b-table
                :data="listOfProductData"
                :paginated="true"
                per-page="50"
                pagination-position="both"
                class="product-table"
              >
                <template slot-scope="props">
                  <b-table-column field="title" label="タイトル" sortable>
                    {{ props.row.title }}
                  </b-table-column>
                  <b-table-column field="classification_code" label="分類">
                    {{ props.row.classificationName }}
                  </b-table-column>
                  <b-table-column field="product_code" label="製品名">
                    {{ props.row.productNames }}
                  </b-table-column>
                  <b-table-column field="target_audience_code" label="対象者">
                    {{ props.row.targetAudienceName }}
                  </b-table-column>
                  <b-table-column field="pdfUrl" label="PDF閲覧" centered>
                    <a
                      @click="downloadFile(props.row.pdfFileUrl)"
                      v-show="props.row.pdfFileUrl"
                      ><b-icon icon="clipboard-arrow-right-outline"
                    /></a>
                  </b-table-column>
                  <b-table-column
                    field="externalUrl"
                    label="関連サイト"
                    centered
                  >
                    <a
                      @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                      class="infoicon"
                      v-show="props.row.externalLinkUrl"
                      ><b-icon icon="play-box-multiple"
                    /></a>
                  </b-table-column>
                  <b-table-column
                    field="createdAt"
                    label="作成日"
                    style="font-size: 12px"
                    centered
                    sortable
                  >
                    {{ props.row.createdAt }}
                  </b-table-column>
                  <b-table-column class="edit-icon" label="編集" centered>
                    <a @click="goToArticleEdit(5, props.row.articleId)">
                      <b-icon icon="clipboard-edit-outline" />
                    </a>
                  </b-table-column>
                  <b-table-column class="delete-icon" label="削除" centered>
                    <a @click="deleteArticle(props.row.articleId)">
                      <b-icon icon="delete-forever-outline" />
                    </a>
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
        </b-tab-item>
        <!-- 選択肢リストタブ -->
        <b-tab-item label="選択肢リスト">
          <div style="text-align: left">
            <select
              v-model="portalChoiceType"
              @change="loadPortalOptions()"
              style="width: 200px; border-radius: 4px; height: 36px"
            >
              <option value="1" selected>分類</option>
              <option value="2">製品名</option>
              <option value="3">対象者</option>
            </select>
          </div>
          <div class="button-area">
            <b-button
              @click="addRowData(portalChoiceType)"
              class="is-primary"
              icon-left="table-row-plus-after"
              :disabled="isLockEditButtons"
              >行追加</b-button
            >
          </div>
          <div>
            <div v-show="portalChoiceType == 1">
              <b-table :data="portalCategoryList">
                <template slot-scope="props">
                  <b-table-column field="option_name" label="分類名">
                    <template v-if="props.row.mode == 'edit'">
                      <span class="require"
                        ><input
                          type="text"
                          v-model="props.row.optionName"
                          maxlength="50"
                      /></span>
                    </template>
                    <template v-else>
                      <p>{{ props.row.optionName }}</p>
                    </template>
                  </b-table-column>
                  <b-table-column field="displayOrder" label="表示順">
                    <template v-if="props.row.mode == 'edit'">
                      <span class="require"
                        ><input
                          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                          type="number"
                          min="1"
                          max="999"
                          maxlength="3"
                          v-model="props.row.displayOrder"
                      /></span>
                    </template>
                    <template v-else>
                      <p>{{ props.row.displayOrder }}</p>
                    </template>
                  </b-table-column>
                  <b-table-column field="isDeleted" label="非表示" centered>
                    <b-checkbox
                      v-model="props.row.isDeleted"
                      :disabled="props.row.mode != 'edit'"
                    ></b-checkbox>
                  </b-table-column>
                  <b-table-column class="edit-button">
                    <template v-if="props.row.mode == 'edit'">
                      <b-button
                        class="is-primary half-size-button"
                        @click="saveRowData(props.row)"
                        >保存</b-button
                      >
                      <b-button
                        class="is-primary half-size-button"
                        @click="cancelRowData(props.row, props.index)"
                        >キャンセル</b-button
                      >
                    </template>
                    <template v-else>
                      <b-button
                        class="is-primary"
                        @click="editRowData(props.row, props.index)"
                        :disabled="isLockEditButtons"
                        >編集</b-button
                      >
                    </template>
                  </b-table-column>
                </template>
              </b-table>
            </div>
            <div v-show="portalChoiceType == 2">
              <b-table :data="portalProductList">
                <template slot-scope="props">
                  <b-table-column field="product_code" label="製品名">
                    <template v-if="props.row.mode == 'edit'">
                      <span class="require"
                        ><input
                          type="text"
                          v-model="props.row.optionName"
                          maxlength="50"
                      /></span>
                    </template>
                    <template v-else>
                      <p>{{ props.row.optionName }}</p>
                    </template>
                  </b-table-column>
                  <b-table-column field="classification_code" label="分類">
                    <template v-if="props.row.mode == 'edit'">
                      <span class="require"
                        ><select v-model="props.row.parentOptionId">
                          <option></option>
                          <option
                            v-for="item in selectBoxCategoryList"
                            :key="item.optionValue"
                            :value="item.optionValue"
                          >
                            {{ item.optionName }}
                          </option>
                        </select></span
                      >
                    </template>
                    <template v-else>
                      <p>{{ setCategoryName(props.row.parentOptionId) }}</p>
                    </template>
                  </b-table-column>
                  <b-table-column field="attribute" label="サービス">
                    <b-checkbox
                      v-model="props.row.isHst"
                      :disabled="props.row.mode != 'edit'"
                    />：睡眠検査機器配送サービス<br />
                    <b-checkbox
                      v-model="props.row.isPsg"
                      :disabled="props.row.mode != 'edit'"
                    />：PSG解析<br />
                    <b-checkbox
                      v-model="props.row.isCorp"
                      :disabled="props.row.mode != 'edit'"
                    />：企業検診<br />
                    <b-checkbox
                      v-model="props.row.isHolter"
                      :disabled="props.row.mode != 'edit'"
                    />：ホルター心電図配送サービス<br />
                    <b-checkbox
                      v-model="props.row.isCpap"
                      :disabled="props.row.mode != 'edit'"
                    />：CPAP指示書登録サービス<br />
                    <b-checkbox
                      v-model="props.row.isCo"
                      :disabled="props.row.mode != 'edit'"
                    />：ケアオーケストレーター
                  </b-table-column>
                  <b-table-column field="attribute7" label="睡眠">
                    <b-checkbox
                      v-model="props.row.isSleep"
                      :disabled="props.row.mode != 'edit'"
                    ></b-checkbox>
                  </b-table-column>
                  <b-table-column field="attribute8" label="呼吸">
                    <b-checkbox
                      v-model="props.row.isBreathing"
                      :disabled="props.row.mode != 'edit'"
                    ></b-checkbox>
                  </b-table-column>
                  <b-table-column field="displayOrder" label="表示順">
                    <template v-if="props.row.mode == 'edit'">
                      <span class="require"
                        ><input
                          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                          type="number"
                          min="1"
                          max="999"
                          maxlength="3"
                          v-model="props.row.displayOrder"
                      /></span>
                    </template>
                    <template v-else>
                      <p>{{ props.row.displayOrder }}</p>
                    </template>
                  </b-table-column>
                  <b-table-column field="isDeleted" label="非表示" centered>
                    <b-checkbox
                      v-model="props.row.isDeleted"
                      :disabled="props.row.mode != 'edit'"
                    ></b-checkbox>
                  </b-table-column>
                  <b-table-column class="edit-button">
                    <template v-if="props.row.mode == 'edit'">
                      <b-button
                        class="is-primary half-size-button"
                        @click="saveRowData(props.row)"
                        >保存</b-button
                      >
                      <b-button
                        class="is-primary half-size-button"
                        @click="cancelRowData(props.row, props.index)"
                        >キャンセル</b-button
                      >
                    </template>
                    <template v-else>
                      <b-button
                        class="is-primary"
                        @click="editRowData(props.row, props.index)"
                        :disabled="isLockEditButtons"
                        >編集</b-button
                      >
                    </template>
                  </b-table-column>
                </template>
              </b-table>
            </div>
            <div v-show="portalChoiceType == 3">
              <b-table :data="portalTargetAudienceList">
                <template slot-scope="props">
                  <b-table-column field="option_name" label="対象者名">
                    <template v-if="props.row.mode == 'edit'">
                      <span class="require"
                        ><input
                          type="text"
                          v-model="props.row.optionName"
                          maxlength="50"
                      /></span>
                    </template>
                    <template v-else>
                      <p>{{ props.row.optionName }}</p>
                    </template>
                  </b-table-column>
                  <b-table-column field="displayOrder" label="表示順">
                    <template v-if="props.row.mode == 'edit'">
                      <span class="require"
                        ><input
                          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                          type="number"
                          min="1"
                          max="999"
                          maxlength="3"
                          v-model="props.row.displayOrder"
                      /></span>
                    </template>
                    <template v-else>
                      <p>{{ props.row.displayOrder }}</p>
                    </template>
                  </b-table-column>
                  <b-table-column field="isDeleted" label="非表示" centered>
                    <b-checkbox
                      v-model="props.row.isDeleted"
                      :disabled="props.row.mode != 'edit'"
                    ></b-checkbox>
                  </b-table-column>
                  <b-table-column class="edit-button">
                    <template v-if="props.row.mode == 'edit'">
                      <b-button
                        class="is-primary half-size-button"
                        @click="saveRowData(props.row)"
                        >保存</b-button
                      >
                      <b-button
                        class="is-primary half-size-button"
                        @click="cancelRowData(props.row, props.index)"
                        >キャンセル</b-button
                      >
                    </template>
                    <template v-else>
                      <b-button
                        class="is-primary"
                        @click="editRowData(props.row, props.index)"
                        :disabled="isLockEditButtons"
                        >編集</b-button
                      >
                    </template>
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
        </b-tab-item>
        <!-- 定期メールタブ -->
        <b-tab-item label="定期メール">
          <div class="mail-content-area">
            <table>
              <tr>
                <td style="width: 80px">件名</td>
                <td>
                  <input type="text" v-model="mailSubject" maxlength="50" />
                </td>
              </tr>
              <tr>
                <td>本文</td>
                <td>
                  <textarea
                    class="noresize"
                    style="width: 100%; line-height: 1; height: 20em"
                    v-model="mailContent"
                    maxlength="500"
                  ></textarea>
                </td>
              </tr>
            </table>
            <div>
              <b-button class="is-primary" @click="mailSave()"
                >保存する</b-button
              >
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>
var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
export default {
  data() {
    return {
      userInfo,
      listOfNoticeData: [],
      listOfGuidanceData: [],
      listOfEventData: [],
      listOfNewsData: [],
      listOfProductData: [],
      portalCategoryList: [],
      portalProductList: [],
      portalTargetAudienceList: [],
      selectBoxCategoryList: [],
      articleType: 1,
      portalChoiceType: 1,
      type: "",
      mailSubject: "",
      mailContent: "",
      mailId: "",
      categoryRowDataBeforeEdit: {},
      productRowDataBeforeEdit: {},
      targetAudienceRowDataBeforeEdit: {},
      isLockEditButtons: false,
      categoryFormat: { open: true, edit: false },
      caseCheck: "",
    };
  },
  methods: {
    goToArticleEdit(type, articleId) {
      let params = "?type=" + type;
      if (articleId) {
        params += "&articleId=" + articleId;
      }
      this.$router.push({ path: "portal-setting/article-edit" + params });
    },
    goToExternalLinkUrl(externalLinkUrl) {
      const url = externalLinkUrl;
      window.open(url, "_blank");
    },
    // ポータル設定画面　掲載記事取得
    loadPortalArticle() {
      const THIS = this;
      requestArticleType = this.$route.query.type;
      if (this.$route.query.type > 0) {
        this.articleType = this.$route.query.type;
        this.$route.query.type = "";
      }
      let requestArticleType = {
        article_type_code: this.articleType,
      };
      return this.apiCall(
        function (client) {
          return client.apis.portalSetting.loadPortalArticle(
            requestArticleType
          );
        },
        function (success) {
          THIS.listOfNoticeData = success.obj.portalArticleList;
          THIS.listOfGuidanceData = success.obj.portalArticleList;
          THIS.listOfEventData = success.obj.portalArticleList;
          THIS.listOfNewsData = success.obj.portalArticleList;
          THIS.listOfProductData = success.obj.portalArticleList;
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },
    loadPortalOptions() {
      const THIS = this;
      let requestPortalChoiceType = {
        portal_option_type_code: this.portalChoiceType,
      };
      this.apiCall(
        function (client) {
          return client.apis.portalSetting.loadPortalOptions(
            requestPortalChoiceType
          );
        },
        function (success) {
          THIS.portalCategoryList = success.obj.portalOptionList;
          THIS.portalProductList = success.obj.portalOptionList;
          THIS.portalTargetAudienceList = success.obj.portalOptionList;
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
      this.isLockEditButtons = false;
    },
    //
    downloadFile(fileAddress) {
      this.apiCall(
        function (client) {
          return client.apis.apiCommon.getDownloadFilePOST({
            body: {
              fileId: 0,
              fileName: fileAddress,
            },
          });
        },
        function (result) {
          var downloadUrl = result.obj.downloadUrl;
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = downloadUrl;
          a.target = "_blank";
          a.click();
          a.remove();
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },
    //掲載記事削除
    deleteArticle(articleId) {
      var THIS = this;
      this.$dialog.confirm({
        title: "掲載記事削除",
        message: "この記事を削除します。",
        cancelText: "キャンセル",
        onConfirm: async () => {
          return this.apiCall(
            function (client) {
              return client.apis.portalSetting.deletePortalArticle({
                body: { articleId: articleId },
              });
            },
            function (result) {
              THIS.showSuccess(result, THIS.loadPortalArticle);
            },
            function (error) {
              THIS.showErrorMessage(error);
            }
          );
        },
      });
    },
    //定期メール文取得
    loadPortalMailContents() {
      const THIS = this;
      return this.apiCall(
        function (client) {
          return client.apis.portalSetting.loadPortalMailContents();
        },
        // 定期メール画面　メール文取得
        function (success) {
          THIS.mailId = success.obj.mailId;
          THIS.mailSubject = success.obj.subject;
          THIS.mailContent = success.obj.content;
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },
    mailSave() {
      const THIS = this;
      let body = {
        mailId: this.mailId,
        subject: this.mailSubject,
        content: this.mailContent,
      };
      return this.apiCall(
        function (client) {
          return client.apis.portalSetting.savePortalMailContents({
            body: body,
          });
        },
        function (result) {
          THIS.showSuccess(result, function () {});
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },

    loadPortalSelectBoxItems() {
      const THIS = this;
      return this.apiCall(
        function (client) {
          return client.apis.portalSetting.loadPortalSelectBoxItems();
        },
        function (result) {
          THIS.selectBoxCategoryList = result.obj.classificationSelectItemList;
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },

    setCategoryName(parentOptionId) {
      let item = this.selectBoxCategoryList.filter((v) => {
        return v.optionValue == parentOptionId;
      })[0];
      if (item) {
        return item.optionName;
      }
      return "";
    },
    addRowData() {
      this.isLockEditButtons = true;
      if (this.portalChoiceType == "1") {
        this.portalCategoryList.push({
          portalOptionTypeCode: "1",
          optionId: "",
          optionName: "",
          displayOrder: "",
          isDeleted: false,
          mode: "edit",
        });
      } else if (this.portalChoiceType == "2") {
        this.portalProductList.push({
          portalOptionTypeCode: "2",
          optionId: "",
          parentOptionId: "",
          optionName: "",
          displayOrder: "",
          isHst: false,
          isPsg: false,
          isCorp: false,
          isHolter: false,
          isCpap: false,
          isCo: false,
          isSleep: false,
          isBreathing: false,
          isDeleted: false,
          mode: "edit",
        });
      } else if (this.portalChoiceType == "3") {
        this.portalTargetAudienceList.push({
          portalOptionTypeCode: "3",
          optionId: "",
          optionName: "",
          displayOrder: "",
          isDeleted: false,
          mode: "edit",
        });
      }
    },
    editRowData(rowData, index) {
      this.isLockEditButtons = true;
      if (this.portalChoiceType == "1") {
        this.categoryRowDataBeforeEdit = JSON.parse(JSON.stringify(rowData));
        this.portalCategoryList[index].mode = "edit";
        this.portalCategoryList.push();
      } else if (this.portalChoiceType == "2") {
        this.productRowDataBeforeEdit = JSON.parse(JSON.stringify(rowData));
        this.portalProductList[index].mode = "edit";
        this.portalProductList.push();
      } else if (this.portalChoiceType == "3") {
        this.targetAudienceRowDataBeforeEdit = JSON.parse(
          JSON.stringify(rowData)
        );
        this.portalTargetAudienceList[index].mode = "edit";
        this.portalTargetAudienceList.push();
      }
    },
    cancelRowData(rowData, index) {
      if (this.portalChoiceType == "1") {
        if (rowData.optionId == "") {
          this.portalCategoryList.pop();
        } else {
          this.portalCategoryList[index] = this.categoryRowDataBeforeEdit;
          this.categoryRowDataBeforeEdit = {};
          this.portalCategoryList.push();
        }
      } else if (this.portalChoiceType == "2") {
        if (rowData.optionId == "") {
          this.portalProductList.pop();
        } else {
          this.portalCategoryList[index] = this.productRowDataBeforeEdit;
          this.productRowDataBeforeEdit = {};
          this.portalProductList.push();
        }
      } else if (this.portalChoiceType == "3") {
        if (rowData.optionId == "") {
          this.portalTargetAudienceList.pop();
        } else {
          this.portalCategoryList[index] = this.targetAudienceRowDataBeforeEdit;
          this.targetAudienceRowDataBeforeEdit = {};
          this.portalTargetAudienceList.push();
        }
      }
      this.isLockEditButtons = false;
    },
    saveRowData(rowData) {
      if (
        rowData.portalOptionTypeCode == 1 &&
        rowData.optionName &&
        rowData.displayOrder
      ) {
        this.caseCheck = "10";
      } else if (
        rowData.portalOptionTypeCode == 2 &&
        rowData.parentOptionId &&
        rowData.optionName &&
        rowData.displayOrder
      ) {
        this.caseCheck = "10";
      } else if (
        rowData.portalOptionTypeCode == 3 &&
        rowData.optionName &&
        rowData.displayOrder
      ) {
        this.caseCheck = "10";
      } else {
        this.caseCheck = "20";
      }
      switch (this.caseCheck) {
        case "10":
          let body = {
            optionId: rowData.optionId,
            portalOptionTypeCode: rowData.portalOptionTypeCode,
            optionName: rowData.optionName,
            displayOrder: rowData.displayOrder,
            isDeleted: rowData.isDeleted,
          };
          if (rowData.portalOptionTypeCode == "2") {
            body.parentOptionId = rowData.parentOptionId;
            body.isHst = rowData.isHst;
            body.isPsg = rowData.isPsg;
            body.isCorp = rowData.isCorp;
            body.isHolter = rowData.isHolter;
            body.isCpap = rowData.isCpap;
            body.isCo = rowData.isCo;
            body.isSleep = rowData.isSleep;
            body.isBreathing = rowData.isBreathing;
          }
          let THIS = this;
          this.apiCall(
            function (client) {
              return client.apis.portalSetting.savePortalOption({ body: body });
            },
            function (success) {
              THIS.showSuccess(success);
              THIS.loadPortalOptions();
            },
            function (error) {
              THIS.showErrorMessage(error);
            }
          );
          this.isLockEditButtons = false;
          break;
        case "20":
          this.$dialog.alert({
            title: "入力エラー",
            message: "必須項目が入力されていません。",
          });
          break;
      }
    },
  },
  created() {
    this.loadPortalArticle();
    this.loadPortalOptions();
    this.loadPortalMailContents();
    this.loadPortalSelectBoxItems();
  },
};
</script>

<style scoped>
#portal-setting {
  width: 90%;
  margin: 20px 80px 20px 80px;
}
.title-area {
  margin-bottom: 20px;
}
.content-area {
  margin-top: 10px;
}
.mail-content-area {
  width: 80%;
}
.field {
  text-align: left;
  margin: 10px 0 10px 0;
}
.button-area {
  margin-bottom: 4px;
  text-align: right;
}
.image-file {
  object-fit: contain;
  min-width: 160px;
  max-height: 90px;
}
.edit-button {
  width: 200px;
}
.nowrap {
  white-space: nowrap;
}
</style>
<style>
#portal-setting .tabs.is-boxed li a {
  border: 1px solid;
  margin: 0.5px;
  border-color: #f7f7f7;
  background-color: #e4e4e4;
  border-radius: 8px 8px 0 0;
  width: 150px;
}
#portal-setting .tabs.is-boxed li.is-active a {
  background-color: #061e57 !important;
  border-color: #061e57;
  color: #ffffff;
}
#portal-setting .tabs.is-boxed li a:hover {
  background-color: #061e57;
  border-color: #061e57;
  color: #ffffff;
}
.edit-icon {
  width: 80px;
}
.delete-icon {
  width: 80px;
}
#portal-setting .notice-table td {
  word-break: break-word;
}
/* notice-table */
#portal-setting .notice-table .table > thead > tr > th:nth-child(1) {
  width: 50%;
}
#portal-setting .notice-table .table > thead > tr > th:nth-child(2) {
  width: 300px;
}
#portal-setting .notice-table .table > thead > tr > th:nth-child(3) {
  width: 8%;
}
#portal-setting .notice-table .table > thead > tr > th:nth-child(4) {
  width: 5%;
}
#portal-setting .notice-table .table > thead > tr > th:nth-child(5) {
  width: 5%;
}
/* guidance-table */
#portal-setting .guidance-table .table > thead > tr > th:nth-child(1) {
  width: 50%;
}
#portal-setting .guidance-table .table > thead > tr > th:nth-child(2) {
  width: 9%;
}
#portal-setting .guidance-table .table > thead > tr > th:nth-child(3) {
  width: 20%;
}
#portal-setting .guidance-table .table > thead > tr > th:nth-child(4) {
  width: 5%;
}
#portal-setting .guidance-table .table > thead > tr > th:nth-child(5) {
  width: 6%;
}
#portal-setting .guidance-table .table > thead > tr > th:nth-child(6) {
  width: 5%;
}
#portal-setting .guidance-table .table > thead > tr > th:nth-child(7) {
  width: 5%;
}
/* event-table */
#portal-setting .event-table .table > thead > tr > th:nth-child(1) {
  width: auto;
}
#portal-setting .event-table .table > thead > tr > th:nth-child(2) {
  width: 38%;
}
#portal-setting .event-table .table > thead > tr > th:nth-child(3) {
  width: 24%;
}
#portal-setting .event-table .table > thead > tr > th:nth-child(4) {
  width: 7%;
}
#portal-setting .event-table .table > thead > tr > th:nth-child(5) {
  width: 7%;
}
#portal-setting .event-table .table > thead > tr > th:nth-child(6) {
  width: 7%;
}
#portal-setting .event-table .table > thead > tr > th:nth-child(7) {
  width: 6%;
}
#portal-setting .event-table .table > thead > tr > th:nth-child(8) {
  width: 6%;
}
/* news-table */
#portal-setting .news-table .table > thead > tr > th:nth-child(1) {
  width: auto;
}
#portal-setting .news-table .table > thead > tr > th:nth-child(2) {
  width: 78%;
}
#portal-setting .news-table .table > thead > tr > th:nth-child(3) {
  width: 10%;
}
#portal-setting .news-table .table > thead > tr > th:nth-child(4) {
  width: 6%;
}
#portal-setting .news-table .table > thead > tr > th:nth-child(5) {
  width: 6%;
}
/* product-table */
#portal-setting .product-table .table > thead > tr > th:nth-child(1) {
  width: 46%;
}
#portal-setting .product-table .table > thead > tr > th:nth-child(2) {
  width: 9%;
}
#portal-setting .product-table .table > thead > tr > th:nth-child(3) {
  width: 13%;
}
#portal-setting .product-table .table > thead > tr > th:nth-child(4) {
  width: 7%;
}
#portal-setting .product-table .table > thead > tr > th:nth-child(5) {
  width: 5%;
}
#portal-setting .product-table .table > thead > tr > th:nth-child(6) {
  width: 6%;
}
#portal-setting .product-table .table > thead > tr > th:nth-child(7) {
  width: 8%;
}
#portal-setting .product-table .table > thead > tr > th:nth-child(8) {
  width: 3%;
}
#portal-setting .product-table .table > thead > tr > th:nth-child(9) {
  width: 3%;
}
.half-size-button {
  width: 45%;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/portal/PortalSetting.vue